<template>
    <div class="container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
            <el-breadcrumb separator="">
                <el-breadcrumb-item>
                    <div class="div1">基本配置</div>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <div class="div2">系统文件</div>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 面包屑导航 teamManage -->
        <!-- 添加团队 -->
        <!-- 添加团队 -->
        <!-- 管理团队 -->
        <div class="manage">
            <div class="header" style="display:flex;align-items:center;justify-content:space-between;">
                <p>列表数据</p>
                <el-button type="primary" size="medium" @click="toAdd">新增</el-button>
            </div>
            <div class="table">
                <vxe-table align="center" keep-source :data="list">
                    <vxe-table-column title="ID" field="id" width="55"></vxe-table-column>
                    <vxe-table-column title="标题" field="title"></vxe-table-column>

                    <vxe-table-column title="操作">
                        <template slot-scope="scope">
                            <el-button type="text" plain @click="toAdd(scope.row.id)">查看/编辑</el-button>
                            <el-button type="text" plain @click="copyFn(scope.row.id)">复制链接</el-button>
                            <!-- <el-button type="text" plain @click="deleteFn(scope.row.id)">删除</el-button> -->
                        </template>
                    </vxe-table-column>
                </vxe-table>

            </div>
        </div>
        <!-- 管理客户等级 -->
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            formInline: {
                name: "",
                code: "",
                remark: "",
            },
            select: [],
            selectType: [],
            tableData: [],
            currentPage1: 1,
            bumenId: "",
            lxId: "",
            limits: "",
            parArray: [],
            pageSize: 10,
            pageNo: 1,
            list: []
        };
    },
    created() {
        this.getList()
    },
    activated() {
        // this.positionList("1");//查询职位列表
    },
    methods: {
        deleteFn(id){

        },
        copyFn(id) {
            let text = 'https://nc.5eck.cn/agreement.html?id=' + id
            this.$copyText(text).then(
                e => {
                    this.$message.success('复制成功')
                    console.log('复制成功：', e);
                },
                e => {
                    console.log('复制失败：', e);
                }
            )
        },
        toAdd(id) {
            this.$router.push({
                name: 'editSysText',
                query: {
                    id: id || ''
                }
            })
        },
        handleCurrentChange(val) {
            this.positionList(`${val}`);
        },
        getList() {
            let data = {
                pageSize: this.pageSize,
                pageNo: this.pageNo
            }
            this.axios.post('/sys/sysText/pageList', data)
                .then(res => {
                    console.log(res)
                    this.list = res.data.list;
                })
        },

        // 修改职位名称end
        /***删除职位***/
        delect(row, index) {
            this.$confirm("确定要删除该职位吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.axios
                        .post(
                            "/sys/v1/position/delete",
                            {
                                request: {
                                    id: row.id,
                                    userId: sessionStorage.getItem("user_id"),
                                },
                                version: "",
                            },
                            {
                                headers: {
                                    isLoading: false,
                                },
                            }
                        )
                        .then((res) => {
                            console.log(res);
                            if (res.code == 0) {
                                this.tableData.list.splice(index, 1);
                                this.positionList("1");
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        /***删除职位 end***/
    },
};
</script>
  
<style scoped lang="scss">
.div1 {
    margin-left: -16px;
    background: url(../../../assets/breadcrumb2.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #2d7edf;
}

.div2 {
    margin-left: -16px;
    background: url(../../../assets/breadcrumb1.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
}

.div3 {
    margin-left: -8px;
    background: url(../../../assets/breadcrumb3.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #2d7edf;
}

.content {
    padding: 10px;
    background: #fff;

    .el-button {
        padding: 6px 10px;
    }
}

.header {
    font-size: 16px;
    color: #2d7edf;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.demo-form-inline {
    margin-top: 10px;
}

/deep/.el-input__inner {
    height: 30px;
    line-height: 30px;
}

.manage {
    margin-top: 20px;
    padding: 10px;
    background: #fff;
}

/deep/.has-gutter .cell {
    text-align: center;
    color: #2d7ddf;
}

/deep/.cell {
    text-align: center;
}

.name {
    font-size: 16px;
    color: #2d7edf;
    margin: 10px 0;
}

.optain {
    width: 100%;
    text-align: center;

    p {
        display: inline-block;
        vertical-align: middle;
        // margin-left: 20px;
        margin: 0 10px;
        color: #2D7DDF;

        img {
            width: 18px;
            height: 20px;
            margin-top: 8px;
        }
    }
}

.page {
    text-align: right;
    margin-top: 20px;

    span {
        font-size: 15px;
        color: #666;
        display: inline-block;
        margin-left: 10px;
        vertical-align: middle;
    }

    .el-pagination {
        display: inline-block;
        vertical-align: middle;
    }
}

.vxe-header--row {
    background: #fff;
}
</style>
  